import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { cartPopUpReducer } from "./cartPopUp/cartPopUpSlice";
import { marketing } from "./api/marketingApi";
import { stepperReducer } from "./stepper/stepperSlice";
import { dealerReducer } from "./dealer/dealerSlice";
import {cartReducer} from "@/redux-store/cart/cartSlice.ts";
import {loadCartFromLocalStorage, saveCartToLocalStorage} from "@/redux-store/cart/cartStorage.ts";

const preloadedState = {
  cart: loadCartFromLocalStorage() || undefined,
};

export const store = configureStore({
  reducer: {
    [marketing.reducerPath]: marketing.reducer,
    cart: cartReducer,
    cartPopUp: cartPopUpReducer,
    stepper: stepperReducer,
    dealer: dealerReducer,
  },
  preloadedState,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(marketing.middleware),
});

store.subscribe(() => {
  saveCartToLocalStorage(store.getState().cart);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
